export function programSearchForm() {
    const programSearchWrap = $('.program-search-form');
    const form = programSearchWrap.find('form [type="submit"]');
    const selects = form.closest("form").find('select[required]');
    const errorText = "error";

    form.on("click", function (e) {

        selects.each((index, select) => {
            if ( !$(select).val() ) {
                let parent = $(select).closest(".form-item");

                if (!parent.hasClass(errorText)) {
                    parent.addClass(errorText).append("<span class='error-text'>The field must not be empty</span>");
                }

                return false;
            }
        });
    });

    selects.on("change", function (e) {
        let parent = $(this).closest(".form-item");
        if (parent.hasClass(errorText)) {
            parent.removeClass(errorText).find(".error-text").remove();
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/programSearchForm.js